module.exports = __webpack_public_path__ + "img/maum_main.f0422676.png";